import { ImportData } from '../types';

export const mockImportData: ImportData = {
  metadata: {
    reference: 'DEV-2024-0847',
    fournisseur: 'Entreprise Martin & Fils',
    dateDevis: '2024-11-15',
    client: 'SCI Les Jardins du Parc',
    chantier: 'Résidence Le Clos Fleuri — Bât. A',
    lotOuCorps: 'Lot 04 — Gros œuvre',
  },
  pdfUrl: '/sample-devis.pdf',
  totalPages: 4,
  lines: [
    // ── Titre section 1 ──
    {
      id: 'title-01',
      article: '04',
      designation: 'INFRASTRUCTURES',
      unite: '',
      quantite: null,
      prixUnitaire: null,
      confidence: 'high',
      pdfRegion: { page: 1, x: 5, y: 18, width: 90, height: 4 },
      isTitle: true,
    },
    {
      id: 'line-001',
      article: '04.01',
      designation: 'Terrassement en pleine masse y compris évacuation des terres',
      unite: 'm³',
      quantite: 245,
      prixUnitaire: 38.50,
      confidence: 'high',
      pdfRegion: { page: 1, x: 5, y: 22, width: 90, height: 4 },
      classification: { lotId: 'fondation', ensembleId: 'ens-fondation-superficielle', sousEnsembleId: 'se-fond-terrassement', status: 'suggested' },
    },
    {
      id: 'line-002',
      article: '04.02',
      designation: 'Fouilles en rigoles pour fondations',
      unite: 'ml',
      quantite: 186,
      prixUnitaire: 24.00,
      confidence: 'high',
      pdfRegion: { page: 1, x: 5, y: 27, width: 90, height: 4 },
      classification: { lotId: 'fondation', ensembleId: 'ens-fondation-superficielle', sousEnsembleId: 'se-fond-terrassement', status: 'suggested' },
    },
    {
      id: 'line-003',
      article: '04.03',
      designation: 'Béton de propreté ép. 5 cm sous semelles',
      unite: 'm²',
      quantite: 62,
      prixUnitaire: 18.75,
      confidence: 'medium',
      cellConfidence: { quantite: 'low', prixUnitaire: 'medium' },
      pdfRegion: { page: 1, x: 5, y: 32, width: 90, height: 4 },
      classification: { lotId: 'fondation', ensembleId: 'ens-fondation-superficielle', sousEnsembleId: 'se-fond-proprete', status: 'suggested' },
    },
    {
      id: 'line-004',
      article: '04.04',
      designation: 'Semelles filantes en béton armé dosé à 350 kg/m³',
      unite: 'ml',
      quantite: 186,
      prixUnitaire: 85.00,
      confidence: 'high',
      pdfRegion: { page: 1, x: 5, y: 37, width: 90, height: 4 },
    },
    {
      id: 'line-005',
      article: '04.05',
      designation: 'Longrines en béton armé section 20×50',
      unite: 'ml',
      quantite: 94,
      prixUnitaire: 72.30,
      confidence: 'low',
      cellConfidence: { designation: 'low', prixUnitaire: 'low' },
      pdfRegion: { page: 1, x: 5, y: 42, width: 90, height: 4 },
    },

    // ── Titre section 2 ──
    {
      id: 'title-02',
      article: '05',
      designation: 'SUPERSTRUCTURES',
      unite: '',
      quantite: null,
      prixUnitaire: null,
      confidence: 'high',
      pdfRegion: { page: 2, x: 5, y: 8, width: 90, height: 4 },
      isTitle: true,
    },
    {
      id: 'line-006',
      article: '05.01',
      designation: 'Dallage sur terre-plein ép. 15 cm avec treillis soudé ST25',
      unite: 'm²',
      quantite: 320,
      prixUnitaire: 45.60,
      confidence: 'high',
      pdfRegion: { page: 2, x: 5, y: 12, width: 90, height: 4 },
    },
    {
      id: 'line-007',
      article: '05.02',
      designation: 'Voiles béton armé ép. 20 cm',
      unite: 'm²',
      quantite: 480,
      prixUnitaire: 92.00,
      confidence: 'high',
      pdfRegion: { page: 2, x: 5, y: 17, width: 90, height: 4 },
      classification: { lotId: 'go-charpente', ensembleId: 'ens-voile-ba', sousEnsembleId: null, status: 'changed' },
    },
    {
      id: 'line-008',
      article: '05.03',
      designation: 'Plancher BA type prédalles ép. 16+4 avec poutrelles',
      unite: 'm²',
      quantite: 310,
      prixUnitaire: 78.50,
      confidence: 'medium',
      cellConfidence: { unite: 'low', quantite: 'medium' },
      pdfRegion: { page: 2, x: 5, y: 22, width: 90, height: 4 },
    },
    {
      id: 'line-009',
      article: '05.04',
      designation: 'Escalier béton armé coulé en place y compris coffrage',
      unite: 'U',
      quantite: 4,
      prixUnitaire: 3200.00,
      confidence: 'high',
      pdfRegion: { page: 2, x: 5, y: 27, width: 90, height: 4 },
    },

    // ── Titre section 3 ──
    {
      id: 'title-03',
      article: '06',
      designation: 'OUVRAGES DIVERS',
      unite: '',
      quantite: null,
      prixUnitaire: null,
      confidence: 'high',
      pdfRegion: { page: 3, x: 5, y: 8, width: 90, height: 4 },
      isTitle: true,
    },
    {
      id: 'line-010',
      article: '06.01',
      designation: 'Acrotères béton armé h=60 cm',
      unite: 'ml',
      quantite: 72,
      prixUnitaire: 115.00,
      confidence: 'low',
      cellConfidence: { prixUnitaire: 'low' },
      pdfRegion: { page: 3, x: 5, y: 12, width: 90, height: 4 },
    },
    {
      id: 'line-011',
      article: '06.02',
      designation: 'Réservations et trémies dans planchers et voiles',
      unite: 'U',
      quantite: 28,
      prixUnitaire: 45.00,
      confidence: 'medium',
      cellConfidence: { quantite: 'low' },
      pdfRegion: { page: 3, x: 5, y: 17, width: 90, height: 4 },
    },
    {
      id: 'line-012',
      article: '06.03',
      designation: 'Appuis de fenêtres préfabriqués béton',
      unite: 'ml',
      quantite: 54,
      prixUnitaire: 32.00,
      confidence: 'high',
      pdfRegion: { page: 3, x: 5, y: 22, width: 90, height: 4 },
    },
    {
      id: 'line-013',
      article: '06.04',
      designation: 'Seuils de portes en béton préfabriqué',
      unite: 'ml',
      quantite: 18,
      prixUnitaire: 28.50,
      confidence: 'high',
      pdfRegion: { page: 3, x: 5, y: 27, width: 90, height: 4 },
    },
    {
      id: 'line-014',
      article: '06.05',
      designation: 'Chapes de finition ép. 5 cm incorporées',
      unite: 'm²',
      quantite: 310,
      prixUnitaire: 14.20,
      confidence: 'medium',
      cellConfidence: { designation: 'medium', prixUnitaire: 'low' },
      pdfRegion: { page: 3, x: 5, y: 32, width: 90, height: 4 },
    },
  ],
};
